//获取当前时间(年月日时分秒)
export function getcurrentTime() {
  let date = new Date();
  let Y = date.getFullYear(); //获取系统的年；
  let M = date.getMonth() + 1; //获取系统月份，由于月份是从0开始计算，所以要加1
  let D = date.getDate(); //获取系统日
  let H = date.getHours(); //获取系统时间
  let m = date.getMinutes(); //分
  let s = date.getSeconds(); //秒
  M = M < 10 ? "0" + M : M;
  D = D < 10 ? "0" + D : D;
  H = H < 10 ? "0" + H : H;
  m = m < 10 ? "0" + m : m;
  s = s < 10 ? "0" + s : s;
  return Y + "-" + M + "-" + D + " " + H + ":" + m + ":" + s;
  //   return Y + "年" + M + "月" + D + "日" + H + "时" + m + "分" + s + "秒";
}

// 将数据库返回的字符转数字转为数组类型
// 如果要重新添加到数据库的话使用typeof判断类型
export function ConvertArray(value) {
  // console.log(value);
  var arr = [];
  if (typeof value == "string") {
    arr = value.split(",").map(Number);
    return arr;
  } else {
    return arr.join();
  }
}

export function fn(menu, ChildNode) {
  console.log(menu, ChildNode);
  // for (let a = 0; a < menu.length; a++) {
  //   console.log(menu[a]);
  //   for (let b = 0; b < ChildNode.length; b++) {
  //     console.log(ChildNode[b]);
  //     if(menu[a].id==ChildNode[b]){
  //       console.log(menu[a],'一级父id');
  //     }

  //   }
  // }
  menu
    .filter(item => ChildNode.includes(item.id))
    .map(item => ({
      ...item,
      children: item.children.filter(item1 => ChildNode.includes(item1.id))
    }));
}

/**
* 字符串是否非空
*/
export function isString(itemObject) {
  let ob = `${getFormatString(itemObject)}`;
  if (ob.length > 0) {
      return true;
  }
  return false;
}

function getFormatString(itemObject) {
  let s = `${itemObject}`;
  if (s !== 'null' && s !== 'undefined' && s !== "" && s.length > 0) {
      return s;
  }
  return "";
}


// WEBPACK FOOTER //
// ./src/utils/public.js